import React from "react";
import styles from "../assets/css/benefit.module.scss";
import {Container, Grid, Hidden, Typography} from "@mui/material";

const Benefit = (props) => {


    return <div className={styles.container}>
        <Container maxWidth={"xl"}>
            <Typography variant={"h6"} component={"h4"}>
                {props.title}
            </Typography>
            <Grid container>
                <Grid item xs={12} md={6}>
                    {props.content.map((item, index) => <Item {...item} key={index}/>)}
                </Grid>
                <Grid item xs={12} md={6}>
                    <Hidden mdDown>
                        <div className={styles.videoContainer}>
                            <video loop autoPlay src={props.video} muted/>
                        </div>
                    </Hidden>

                </Grid>
            </Grid>
        </Container>
    </div>
};

const Item = (props) => {
    return <>
        <div className={styles.item}>
            <Typography variant={"body2"} component={"h6"}> ✓ {props.title} </Typography>
            <Typography variant={"subtitle2"} component={"p"} style={{textAlign: "justify"}}>{props.description}</Typography>
        </div>
    </>
}

export default Benefit;